module.exports = __webpack_public_path__ + "img/img2.3802fe3b.png";